// extracted by mini-css-extract-plugin
export default {"inner":"PrivacyPage_inner__+Dm1U","sidebar":"PrivacyPage_sidebar__0o+wf","content":"PrivacyPage_content__hAy28"};